import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w-full space-y-6" }
const _hoisted_2 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CargoTypeSection = _resolveComponent("CargoTypeSection")!
  const _component_CargoFlightManualSection = _resolveComponent("CargoFlightManualSection")!
  const _component_CargoDetailDeliverySection = _resolveComponent("CargoDetailDeliverySection")!
  const _component_WeightSummaryStt = _resolveComponent("WeightSummaryStt")!
  const _component_WeightSummaryTimbangUlang = _resolveComponent("WeightSummaryTimbangUlang")!
  const _component_SectionUploadPhotoForWeightAdjusment = _resolveComponent("SectionUploadPhotoForWeightAdjusment")!
  const _component_CargoTableSttSection = _resolveComponent("CargoTableSttSection")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_CargoTypeSection),
    _hoisted_2,
    (_ctx.isCargoPlaneManual)
      ? (_openBlock(), _createBlock(_component_CargoFlightManualSection, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.isFillForm)
      ? (_openBlock(), _createBlock(_component_CargoDetailDeliverySection, { key: 1 }))
      : _createCommentVNode("", true),
    (_ctx.isFillForm)
      ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
          _createVNode(_component_WeightSummaryStt),
          _createVNode(_component_WeightSummaryTimbangUlang, {
            modelValue: _ctx.formBooking,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formBooking = $event)),
            isDimensionChanged: _ctx.isDimensionChanged,
            "onUpdate:isDimensionChanged": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDimensionChanged = $event)),
            grossWeight: _ctx.sttCalculation.grossWeight,
            volumeWeight: _ctx.sttCalculation.volumeWeight,
            actualChargeableWeight: _ctx.actualChargeableWeight,
            isValidationAdjustWeightProofPhotoEnable: _ctx.isValidationAdjustWeightProofPhotoEnable
          }, null, 8, ["modelValue", "isDimensionChanged", "grossWeight", "volumeWeight", "actualChargeableWeight", "isValidationAdjustWeightProofPhotoEnable"]),
          (_ctx.isErrorWeightAdjustment)
            ? (_openBlock(), _createBlock(_component_SectionUploadPhotoForWeightAdjusment, {
                key: 0,
                class: "mt-5",
                title: "Upload bukti foto untuk ubah berat",
                marginBottom: false,
                defaultOpened: true,
                showViewAdjustment: _ctx.openAdjustmentWeight,
                "onUpdate:showViewAdjustment": _cache[3] || (_cache[3] = ($event: any) => (_ctx.openAdjustmentWeight = $event)),
                modelValue: _ctx.formBooking.photoProof,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formBooking.photoProof = $event)),
                showDefault: true,
                isValidationAdjustWeightProofPhotoEnable: _ctx.isValidationAdjustWeightProofPhotoEnable,
                onOnUploadImage: _ctx.onUploadAdjustmentWeight,
                onOnDeleteImage: _ctx.onRemoveAdjustmentWeight,
                onShowViewAdjustment: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openAdjustmentWeight = !_ctx.openAdjustmentWeight))
              }, null, 8, ["showViewAdjustment", "modelValue", "isValidationAdjustWeightProofPhotoEnable", "onOnUploadImage", "onOnDeleteImage"]))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _hoisted_3,
    _createVNode(_component_CargoTableSttSection)
  ]))
}